import { render, staticRenderFns } from "./ControlHeader.vue?vue&type=template&id=c32e7ec0&scoped=true&"
import script from "./ControlHeader.vue?vue&type=script&lang=js&"
export * from "./ControlHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32e7ec0",
  null
  
)

export default component.exports